var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1C9.512 1 1 9.512 1 20C1 30.488 9.512 39 20 39C30.488 39 39 30.488 39 20C39 9.512 30.488 1 20 1ZM28.816 13.92C28.531 16.922 27.296 24.218 26.669 27.581C26.403 29.006 25.871 29.481 25.377 29.538C24.275 29.633 23.439 28.816 22.375 28.113C20.703 27.011 19.753 26.327 18.138 25.263C16.257 24.028 17.473 23.344 18.556 22.242C18.841 21.957 23.705 17.53 23.8 17.131C23.8132 17.0706 23.8114 17.0078 23.7949 16.9482C23.7783 16.8886 23.7475 16.834 23.705 16.789C23.591 16.694 23.439 16.732 23.306 16.751C23.135 16.789 20.475 18.556 15.288 22.052C14.528 22.565 13.844 22.831 13.236 22.812C12.552 22.793 11.26 22.432 10.291 22.109C9.094 21.729 8.163 21.52 8.239 20.855C8.277 20.513 8.752 20.171 9.645 19.81C15.193 17.397 18.879 15.801 20.722 15.041C26.004 12.837 27.087 12.457 27.809 12.457C27.961 12.457 28.322 12.495 28.55 12.685C28.74 12.837 28.797 13.046 28.816 13.198C28.797 13.312 28.835 13.654 28.816 13.92Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e1eef925f88caa7325785ea18421ed46.svg";
export { ForwardRef as ReactComponent };